var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-layout__inner w-100",attrs:{"id":"structure-create"}},[_c('div',{staticClass:"row w-100"},[_c('div',{staticClass:"col-md-7"},[_c('div',{staticClass:"section"},[_c('EditCreateComponent')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }